/* eslint-disable camelcase */
/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable react/prop-types */
import { makeStyles } from "@material-ui/core";
import LoadingSpinner from "app/auth/utils/LoadingSpinnerComponent";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import _ from "lodash";
import { RiFileExcel2Line } from "react-icons/ri";
import mixpanelTrack from "app/common/MixpanelComponent";
import useSummaryFilters from "../summary-filters/useSummaryFilters";
import PromotionsBubbleChartComponent from "./PromotionsBubbleChartComponent";
import PromotionsLegend from "./PromotionsLegend";
import PromotionsProductsTable from "./PromotionsProductsTable";
import PromotionsTabsSwitch from "./PromotionsTabsSwitch";
import PromotionsTotalsTable from "./PromotionsTotalsTable";
import ScenariosDropdownPromotionsButton from "./scenarios-dropdown/ScenariosDropdownPromotionsButton";
import ScenariosDropdownPromotionsList from "./scenarios-dropdown/ScenariosDropdownPromotionsList";
import {
  aggregatePromotionsByProductRetailer,
  aggregateScenarioEstimationsByProductRetailerArea,
  downloadPromotionsExcel,
  formatPromotions,
  getBubbleChartOptions,
  getColorById,
  getQuartiles,
  // groupBorderColors,
  // groupColors,
  groupPromosByCategory,
  promotionsFetchDataForScenarios,
  promotionsLegendCategories,
} from "./utils";

const myStyles = makeStyles(() => ({
  mainContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    gap: "5px",
    fontSize: "inherit",
    fontFamily: "inherit",
    paddingBottom: "50px",
  },
  scenarioNameContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    fontSize: "14px",
    fontFamily: "inherit",
    gap: "5px",
  },
  scenarioName: {
    boxSizing: "border-box",
    fontSize: "inherit",
    fontFamily: "inherit",
    color: "rgb(239, 106, 94)",
  },
  tabsSwitchContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    // padding: "20px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  bubbleChartContainer: {
    boxSizing: "border-box",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    width: "100%",
    padding: "30px 0px",
    gap: "20px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  productsTableContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "row",
    width: "100%",
    // padding: "20px",
    fontSize: "inherit",
    fontFamily: "inherit",
  },
  spinnerContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonTableContainer: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
  buttonDownloadContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "start",
    alignItems: "center",
    padding: "10px 0px",
  },
  buttonDownload: {
    display: "flex",
    maxWidth: "400px",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px 15px",
    // backgroundColor: "rgb(239, 106, 94)",
    backgroundColor: "rgb(24, 31, 43)",
    color: "white",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    gap: "5px",
  },
  selectAnotherScenarioContainer: {
    display: "flex",
    width: "100%",
    height: "100%",
    justifyContent: "center",
    alignItems: "center",
  },
}));

const SummaryPromotionsComponent = () => {
  const classes = myStyles();

  const {
    selectedScenario: selectedScenarioGlobal,
    referenceScenario: referenceScenarioGlobal,
  } = useSelector((state) => state.scenarios);
  const { summaryFilters } = useSelector((state) => state.filters);
  const { totalsByScenarioId } = useSelector((state) => state.scenarios);
  const { brands, products } = useSelector((state) => state.catalog);
  const retailers = useSelector((state) => state.retailers);
  const configCatSlice = useSelector((state) => state.auth.configCatUser);

  const [
    refScenarioAggregatedPromotions,
    setRefScenarioAggregatedPromotions,
  ] = useState([]);
  const [selectedScenario, setSelectedScenario] = useState(
    selectedScenarioGlobal
  );
  const [
    scenarioAggregatedPromotions,
    setScenarioAggregatedPromotions,
  ] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  // const [selected, setSelected] = useState(null);
  const [tabIndex, setTabIndex] = useState(0);
  const [scenarioData, setScenarioData] = useState([]);
  const [refScenarioData, setRefScenarioData] = useState([]);
  const [promotionsLegendFilters, setPromotionsLegendFilters] = useState("");
  const [promotionsChartFilters, setPromotionsChartFilters] = useState({});
  const [legendExploreBy, setLegendExploreBy] = useState("promotions");
  const [legendColorsBy, setLegendColorsBy] = useState({
    promotions: {},
    products: {},
    retailers: {},
    brands: {},
  });

  const { filterScenariosData } = useSummaryFilters();

  useEffect(() => {
    /* MIXPANEL TRACKS */
    mixpanelTrack("Value destroyers visited");
    /* END OF MIXPANEL TRACKS */
  }, []);

  useEffect(() => {
    setIsLoading(true);
    const currentScenario = totalsByScenarioId[selectedScenario.scenario_id];
    const refScenario = totalsByScenarioId[referenceScenarioGlobal.scenario_id];
    const {
      cycle_type_id: currentCycleTypeId,
    } = currentScenario.scenario.cycle;
    const { cycle_type_id: refCycleTypeId } = refScenario.scenario.cycle;
    const requestScenarioData = async () => {
      const [selectedScenarioData, referenceScenarioData] = await Promise.all([
        promotionsFetchDataForScenarios(
          selectedScenario.scenario_id,
          currentCycleTypeId
        ),
        promotionsFetchDataForScenarios(
          referenceScenarioGlobal.scenario_id,
          refCycleTypeId
        ),
      ]);

      setScenarioData(selectedScenarioData);
      setRefScenarioData(referenceScenarioData);
      if (selectedScenarioData && referenceScenarioData) setIsLoading(false);
    };
    requestScenarioData();
  }, [selectedScenario]);

  useEffect(() => {
    setSelectedScenario(selectedScenarioGlobal);
  }, [selectedScenarioGlobal]);

  // aggregate data by product-retailer based on cycle type (monthly or daily)
  useEffect(() => {
    if (scenarioData.length === 0 || refScenarioData.length === 0) return;

    const currentScenario = totalsByScenarioId[selectedScenario.scenario_id];
    const {
      cycle_type_id: currentCycleTypeId,
    } = currentScenario.scenario.cycle;
    // if (currentCycleTypeId !== 4) {
    if (currentCycleTypeId !== 0) {
      const scenarioEstimationsFilteredMap = new Map(
        scenarioData.map((data) => [
          `${data.product_id}-${data.retailer_id}-${data.area_id}`,
          data,
        ])
      );

      const refScenarioEstimationsFilteredMap = new Map(
        refScenarioData.map((data) => [
          `${data.product_id}-${data.retailer_id}-${data.area_id}`,
          data,
        ])
      );

      const scenarioEstimationsPromotions = new Map();
      const refScenarioEstimationsPromotions = new Map();

      scenarioEstimationsFilteredMap.forEach((estimation, key) => {
        const refEstimation = refScenarioEstimationsFilteredMap.get(key);
        // eslint-disable-next-line camelcase
        const { brand_id } = products[estimation?.product_id];
        if (
          refEstimation &&
          estimation.avg_weight_by_units_price <
            refEstimation.avg_weight_by_units_price
        ) {
          scenarioEstimationsPromotions.set(key, {
            ...estimation,
            brand_id,
            product: products[estimation?.product_id],
            retailer: retailers[estimation?.retailer_id],
            brand: brands[brand_id],
          });
          refScenarioEstimationsPromotions.set(key, {
            ...refEstimation,
            brand_id,
            product: products[estimation?.product_id],
            retailer: retailers[estimation?.retailer_id],
            brand: brands[brand_id],
          });
        }
      });

      setScenarioAggregatedPromotions(
        aggregatePromotionsByProductRetailer(scenarioEstimationsPromotions)
      );
      setRefScenarioAggregatedPromotions(
        aggregatePromotionsByProductRetailer(refScenarioEstimationsPromotions)
      );
    } else {
      const scenarioEstimationsDailyGrouped = _.groupBy(
        scenarioData,
        (data) => `${data.product_id}-${data.retailer_id}-${data.area_id}`
      );

      const refScenarioEstimationsDailyGrouped = _.groupBy(
        refScenarioData,
        (data) => `${data.product_id}-${data.retailer_id}-${data.area_id}`
      );

      const aggregatedScenarioEstimationsDaily = aggregateScenarioEstimationsByProductRetailerArea(
        scenarioEstimationsDailyGrouped
      );

      const refAggregatedScenarioEstimationsDaily = aggregateScenarioEstimationsByProductRetailerArea(
        refScenarioEstimationsDailyGrouped
      );

      const scenarioEstimationsPromotionsDaily = new Map();
      const refScenarioEstimationsPromotionsDaily = new Map();

      aggregatedScenarioEstimationsDaily.forEach((estimation, key) => {
        const refEstimation = refAggregatedScenarioEstimationsDaily.get(key);
        // eslint-disable-next-line camelcase
        const { brand_id } = products[estimation?.product_id];
        if (
          refEstimation &&
          estimation.avg_weight_by_units_price <
            refEstimation.avg_weight_by_units_price
        ) {
          scenarioEstimationsPromotionsDaily.set(key, {
            ...estimation,
            brand_id,
            product: products[estimation?.product_id],
            retailer: retailers[estimation?.retailer_id],
            brand: brands[brand_id],
          });
          refScenarioEstimationsPromotionsDaily.set(key, {
            ...refEstimation,
            brand_id,
            product: products[estimation?.product_id],
            retailer: retailers[estimation?.retailer_id],
            brand: brands[brand_id],
          });
        }
      });

      setScenarioAggregatedPromotions(
        aggregatePromotionsByProductRetailer(scenarioEstimationsPromotionsDaily)
      );
      setRefScenarioAggregatedPromotions(
        aggregatePromotionsByProductRetailer(
          refScenarioEstimationsPromotionsDaily
        )
      );
    }
  }, [summaryFilters, scenarioData, refScenarioData]);

  useEffect(() => {
    const filteredBrands = new Map();
    const filteredProducts = new Map();
    const filteredRetailers = new Map();

    Array.from(Object.values(scenarioAggregatedPromotions)).forEach(
      (promotion) => {
        filteredBrands.set(promotion.brand_id, brands[promotion.brand_id]);
        filteredProducts.set(
          promotion.product_id,
          products[promotion.product_id]
        );
        filteredRetailers.set(
          promotion.retailer_id,
          retailers[promotion.retailer_id]
        );
      }
    );

    const productsWithColors = Array.from(
      Object.values(Object.fromEntries(filteredProducts))
    ).map((product) => {
      return [
        product.id,
        {
          id: product.id,
          label: product.label,
          background: getColorById(product.id, 0.5),
          borderColor: getColorById(product.id, 1),
        },
      ];
    });

    const brandsWithColors = Array.from(
      Object.values(Object.fromEntries(filteredBrands))
    ).map((brand) => {
      return [
        brand.id,
        {
          id: brand.id,
          label: brand.label,
          background: getColorById(brand.id, 0.5),
          borderColor: getColorById(brand.id, 1),
        },
      ];
    });

    const retailersWithColors = Array.from(
      Object.values(Object.fromEntries(filteredRetailers))
    ).map((retailer) => {
      return [
        retailer.id,
        {
          id: retailer.id,
          label: retailer.label,
          background: getColorById(retailer.id, 0.5),
          borderColor: getColorById(retailer.id, 1),
        },
      ];
    });
    const promotionsWithColors = Array.from(promotionsLegendCategories).map(
      (promotion) => {
        return [promotion.id, promotion];
      }
    );

    setLegendColorsBy({
      products: Object.fromEntries(productsWithColors),
      brands: Object.fromEntries(brandsWithColors),
      retailers: Object.fromEntries(retailersWithColors),
      promotions: Object.fromEntries(promotionsWithColors),
    });
  }, [products, retailers, brands, scenarioAggregatedPromotions]);

  useEffect(() => {
    setPromotionsLegendFilters("");
  }, [legendExploreBy]);

  const promotions = formatPromotions(
    scenarioAggregatedPromotions,
    refScenarioAggregatedPromotions,
    configCatSlice?.features.newInvestmentCalculation,
    configCatSlice?.features.roiStrategy
  );

  const quartiles = getQuartiles(promotions);

  const getFilteredGroups = () => {
    let promos = [...promotions];
    // apply top level filters (summaryFilters: category, product, brand, retailer)
    promos =
      filterScenariosData({
        [selectedScenario.scenario_id]: promos,
      })[selectedScenario.scenario_id] || [];

    if (promotionsLegendFilters) {
      // apply legend filters (products, retailers, brands)
      if (
        legendExploreBy === "products" &&
        promotionsLegendFilters.legendExploreBy === "products"
      ) {
        const res = Array.from(promos).filter((promo) => {
          return promo.product_id === promotionsLegendFilters.id;
        });
        promos = [...res];
      }
      if (
        legendExploreBy === "brands" &&
        promotionsLegendFilters.legendExploreBy === "brands"
      ) {
        const res = Array.from(promos).filter((promo) => {
          return promo.brand_id === promotionsLegendFilters.id;
        });
        promos = [...res];
      }
      if (
        legendExploreBy === "retailers" &&
        promotionsLegendFilters.legendExploreBy === "retailers"
      ) {
        const res = Array.from(promos).filter((promo) => {
          return promo.retailer_id === promotionsLegendFilters.id;
        });
        promos = [...res];
      }
    }
    // apply legend filters only after grouped by promotion categories (value destroyers, top performers, etc)
    const groups = groupPromosByCategory(promos, quartiles);
    let filteredGroups = {};
    if (
      promotionsLegendFilters &&
      promotionsLegendFilters.legendExploreBy === "promotions"
    ) {
      if (groups[promotionsLegendFilters.label]) {
        filteredGroups = {
          [promotionsLegendFilters.label]:
            groups[promotionsLegendFilters.label],
        };
      }
    } else {
      filteredGroups = groups;
    }

    return filteredGroups;
  };

  const getFilteredItem = () => {
    const filteredGroups = getFilteredGroups();
    if (promotionsChartFilters) {
      // eslint-disable-next-line no-unused-vars
      const entry = Object.entries(filteredGroups).find(([label, data]) =>
        data.some((value) => value.id === promotionsChartFilters)
      );
      if (entry) {
        const [label, data] = entry;
        const foundObj = data.find(
          (value) => value.id === promotionsChartFilters
        );
        return { [label]: [foundObj] };
      }
    }
    return filteredGroups;
  };

  const datasets = Object.entries(getFilteredItem()).map(
    ([promotionLabel, data]) => {
      const promotionKey = promotionsLegendCategories.find(
        (promotionsCat) => promotionLabel === promotionsCat.label
      )?.id;

      // Asigna color a cada burbuja según el campo
      const backgroundColor = Array.from(data).map((item) => {
        if (legendExploreBy === "products") {
          return legendColorsBy[legendExploreBy][item.product_id]?.background;
        }
        if (legendExploreBy === "retailers") {
          return legendColorsBy[legendExploreBy][item.retailer_id]?.background;
        }
        if (legendExploreBy === "brands") {
          return legendColorsBy[legendExploreBy][item.brand_id]?.background;
        }
        return legendColorsBy[legendExploreBy][promotionKey]?.background;
      });
      const borderColor = backgroundColor;

      return {
        label: promotionLabel,
        data,
        backgroundColor,
        borderColor,
        borderWidth: 2,
      };
    }
  );

  const liftsArray = promotions.map((p) => p.lift);
  const maxLift = Math.max(...liftsArray);
  const minLift = Math.min(...liftsArray);

  const ROIArray = promotions.map((p) => p.roi);
  const maxROI = Math.max(...ROIArray);
  const minROI = Math.min(...ROIArray);

  const calculateChartBoundariesFromDatasets = () => {
    const ROIBoundaries = [];
    const LiftBoundaries = [];
    Array.from(datasets).forEach((dataset) => {
      Array.from(dataset.data).forEach((data) => {
        ROIBoundaries.push(data.x);
        LiftBoundaries.push(data.y);
      });
    });
    const maxROIFromDataset = Math.max(...ROIBoundaries) || 0;
    const minROIFromDataset = Math.min(...ROIBoundaries) || 0;
    const maxLiftFromDataset = Math.max(...LiftBoundaries) || 0;
    const minLiftFromDataset = Math.min(...LiftBoundaries) || 0;
    return {
      maxROIFromDataset,
      minROIFromDataset,
      maxLiftFromDataset,
      minLiftFromDataset,
    };
  };

  const {
    maxROIFromDataset,
    minROIFromDataset,
    maxLiftFromDataset,
    minLiftFromDataset,
  } = calculateChartBoundariesFromDatasets();

  const chartData = { datasets };
  const chartOptions = getBubbleChartOptions({
    minROI,
    maxROI,
    maxLift,
    minLift,
    quartiles,
    maxROIFromDataset,
    minROIFromDataset,
    maxLiftFromDataset,
    minLiftFromDataset,
  });

  const getPromotionsTableData = () => {
    const arr = [];
    Array.from(chartData.datasets).forEach((dataset) => {
      const { label, data } = dataset;
      Array.from(data).forEach((value) => {
        arr.push({
          label,
          ...value,
        });
      });
    });
    return arr;
  };

  const promotionsTableData = getPromotionsTableData();

  return (
    <div className={classes.mainContainer}>
      {isLoading ? (
        <div className={classes.spinnerContainer}>
          <LoadingSpinner />
        </div>
      ) : (
        <>
          <div className={classes.tabsSwitchContainer}>
            <ScenariosDropdownPromotionsButton
              selectedScenarioLabel={selectedScenario.scenario.name}
            >
              <ScenariosDropdownPromotionsList
                setSelectedScenario={setSelectedScenario}
              />
            </ScenariosDropdownPromotionsButton>
            <PromotionsTabsSwitch value={tabIndex} onChange={setTabIndex} />
          </div>
          {selectedScenario.scenario?.id !==
          referenceScenarioGlobal.scenario?.id ? (
            <>
              <div className={classes.bubbleChartContainer}>
                {tabIndex === 0 && (
                  <div>
                    <PromotionsBubbleChartComponent
                      chartData={chartData}
                      chartOptions={chartOptions}
                      setPromotionsChartFilters={setPromotionsChartFilters}
                    />
                    <PromotionsLegend
                      legendExploreBy={legendExploreBy}
                      setLegendExploreBy={setLegendExploreBy}
                      categories={legendColorsBy}
                      promotionsLegendFilters={promotionsLegendFilters}
                      setPromotionsLegendFilters={setPromotionsLegendFilters}
                    />
                  </div>
                )}
                {tabIndex === 1 && (
                  <PromotionsTotalsTable datasets={datasets} />
                )}
              </div>
              {tabIndex === 0 && (
                <div className={classes.buttonTableContainer}>
                  <div className={classes.buttonDownloadContainer}>
                    <button
                      className={classes.buttonDownload}
                      type="button"
                      onClick={() => {
                        downloadPromotionsExcel(
                          getPromotionsTableData(),
                          selectedScenario.scenario.name
                        ); /* MIXPANEL TRACKS */
                        mixpanelTrack("Value destroyers excel downloaded");
                        /* END OF MIXPANEL TRACKS */
                      }}
                    >
                      {/* <span style={{ fontSize: "15px" }}>
                    Download selected promotions
                  </span> */}
                      <RiFileExcel2Line size={25} />
                    </button>
                  </div>
                  <div className={classes.productsTableContainer}>
                    <PromotionsProductsTable
                      promotionsTableData={promotionsTableData}
                    />
                  </div>
                </div>
              )}
            </>
          ) : (
            <div className={classes.selectAnotherScenarioContainer}>
              <span style={{ fontSize: "17px", fontWeight: "700" }}>
                This module will compare your current scenario against the
                reference, please choose another scenario from the dropdown to
                start analyzing.
              </span>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default SummaryPromotionsComponent;
